import { useMemo } from 'react';
import { useLinkData } from "$hooks/useLinkData";
import { PostModel } from "$store/models";
import { useTranslator } from "$hooks/useTranslator";
import { format } from "$utils";
import { useUserInfo } from "$hooks/useUserInfo";
import { useGroupInfo } from "$hooks/useGroupInfo";

export const usePostMeta = (post?: PostModel) => {
  const t = useTranslator();
  const user = useUserInfo(post?.ownerId ?? 0);
  const group = useGroupInfo(-(post?.ownerId ?? 0));

  const title = useMemo(() => {
    if (!post) {
      return '';
    }
    const date = format(post.createdAt * 1000, 'd MMMM yyyy в H:i');
    if (post.ownerId < 0) {
      return `Post on group wall at ${date} | ${group?.name} | Ton.Place`;
    }  else {
      return `Post on wall at ${date} | ${user?.firstName} ${user?.lastName} | Ton.Place`;
    }
  }, [post, user, group]);

  const link = post?.attachments?.find((item) => item.type === 'link')?.link;
  const linkData = useLinkData(link);
  const desc = useMemo(() => {
    let result = [post?.text || ''];
    if (post?.attachments) {
      const photos = post.attachments.filter((item) => item.type === 'photo');
      if (photos.length > 0) {
        result.push(t('photos_count', { count: photos.length }));
      }
    }
    return result.filter(item => item.length > 0);
  }, [post]);

  if (link) {
    desc.push(`${linkData.type}: ${linkData.title} → ${linkData.description}. ${linkData.buttonText}`);
  }

  return {
    title: title,
    description: desc.join('. ')
  };
};

